import localDB from "./localDB";

let GLOBAL = require('./globals');

const ProductsIngredientsData = {
    async list() {
        let response = await fetch(`${GLOBAL.BASE_URL}products-ingredients`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
};

export default ProductsIngredientsData;


// WEBPACK FOOTER //
// ./src/data/ProductsIngredientsData.js